export default __webpack_public_path__ + "6f3760d50429d2d160f18d4ea6359108.jpg";